import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern(null, 'modaldelete', () => ({
  state: {
    inputText: null,
  },

  getters: {
    getInputText: (state) => state.inputText,
  },

  actions: {
    async setInputText({ commit }, { inputText }) {
      commit('SET_INPUT_TEXT', inputText);
    },
  },

  mutations: {
    SET_INPUT_TEXT(state, value) {
      state.inputText = value;
    },
  },
}));
